import Vue from "vue";
import VueCollapse from "vue2-collapse";
import TeamComponent from "@/components/TeamComponent";

Vue.config.productionTip = false;

Vue.use(VueCollapse);

if (document.getElementById("vue-team-component")) {
  new Vue({
    render: h => h(TeamComponent)
  }).$mount("#vue-team-component");
}
